export default {"src":"/_next/static/media/users-four.58b1c9a2.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};